export default __webpack_public_path__ + "static/media/lockbackground.3ef5ac74.png";